<template>
  <div class="pt-12" v-if="partnersImages.length">
    <div class="px-8 mb-6 text-center md:text-start">
      <h1
        class="text-cerise-red-600 text-xl leading-6 lg:text-3xl lg:leading-9 font-extrabold mb-3.5"
      >
        Altri vantaggi esclusivi
      </h1>
      <div
        class="md:flex space-y-4 md:space-y-0 text-center md:text-start justify-between items-center -mt-5"
      >
        <p class="pt-6 lg:text-base text-[13px] leading-4 lg:leading-normal">
          Scopri le offerte attive in questo momento con i nostri partner
          selezionati, tutte riservate ai soli clienti registrati
        </p>
        <nuxt-link to="/partners" class="shrink-0">
          <CoreOutlineButton class="my-4 lg:mt-0">
            SCOPRI DI PIÙ
          </CoreOutlineButton>
        </nuxt-link>
      </div>
    </div>
    <div class="lg:px-2.5 relative mb-5">
      <div class="block sm:hidden">
        <SwiperMobileBrandsCarousel
          :slides="partnersImages"
          :slides-per-view="1"
        />
      </div>
      <div class="hidden sm:block swiper__homepage mb-12">
        <Swiper
          :modules="[Pagination, Navigation]"
          @slideChange="onSwiperSlideChange"
          :slides-per-view="5"
          :pagination="{ clickable: true }"
          :grabCursor="true"
          :navigation="{
            nextEl: '.swiper-navigation-next',
            prevEl: '.swiper-navigation-prev',
          }"
          :breakpoints="{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            840: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1040: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1240: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          }"
        >
          <SwiperSlide
            v-for="slide in partnersImages"
            :key="slide"
            class="mt-8 pt-5 px-4"
          >
            <nuxt-img
              :src="slide"
              format="webp"
              class="w-full h-full object-contain rounded-sm"
            />
          </SwiperSlide>
          <SwiperCustomNavigation :current-index="currentIndex" />
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getPartnersData } from "~/composables/partners";
import { Pagination, Navigation } from "swiper/modules";

const currentIndex = ref(null);

function onSwiperSlideChange(swiper) {
  currentIndex.value = swiper.activeIndex;
}

const { images: partnersImages } = await getPartnersData();
</script>
